import axios from 'axios';
import api from './api';
import { USER_API } from '../utils/constants';

// ===== PUBLIC APIs - token nahi chahiye =====
// Inke liye plain axios use karo, api instance nahi

// Registration se pehle OTP bhejo
export const sendRegistrationOtp = async (email, name) => {
    const response = await axios.post(
        `${USER_API}/send-otp`, { email, name });
    return response.data;
};

// OTP verify karo
export const verifyRegistrationOtp = async (email, otp) => {
    const response = await axios.post(
        `${USER_API}/verify-otp`, { email, otp });
    return response.data;
};

// ===== PASSWORD RESET =====
// ⚠️ Ye dono bhi plain axios se - api instance se NAHI.
//
// Kyun: api instance ke interceptor mein 401 pe forceLogout()
// hai. Password reset ke waqt banda logged in hai hi nahi, to
// koi bhi error aane pe wo bekaar mein login page pe phenk
// diya jaata aur bhara hua form gayab ho jaata.

// Step 1 - "password bhool gaya", email pe OTP bhejo
export const sendForgotPasswordOtp = async (email) => {
    const response = await axios.post(
        `${USER_API}/forgot-password`, { email });
    return response.data;
};

// Step 2 - OTP + naya password ek saath
// Kaamyabi pe saare purane session khatam ho jaate hain
export const resetPassword = async (email, otp, newPassword) => {
    const response = await axios.post(
        `${USER_API}/reset-password`, { email, otp, newPassword });
    return response.data;
};

// Register user
export const registerUser = async (userData) => {
    const response = await axios.post(
        `${USER_API}/register`, userData);
    return response.data;
};

// Login - ab poora object aata hai, sirf token nahi
export const loginUser = async (loginData) => {
    const response = await axios.post(
        `${USER_API}/login`, loginData);
    return response.data;
};

// Logout - refresh token backend se hata do
export const logoutUser = async (refreshToken) => {
    if (!refreshToken) return;
    try {
        await axios.post(`${USER_API}/logout`,
            { refreshToken });
    } catch (err) {
        // Logout fail ho toh bhi local clear ho jayega
        console.log('Logout call failed');
    }
};

// ===== PROTECTED APIs - api instance =====

// Get user by ID
export const getUserById = async (id) => {
    const response = await api.get(`${USER_API}/${id}`);
    return response.data;
};

// Get user by email
export const getUserByEmail = async (email) => {
    const response = await api.get(
        `${USER_API}/email/${encodeURIComponent(email)}`);
    return response.data;
};

// Get user by phone number
export const getUserByPhoneNumber = async (phoneNumber) => {
    const response = await api.get(
        `${USER_API}/phone/${encodeURIComponent(phoneNumber)}`);
    return response.data;
};

// Get all users
export const getAllUsers = async () => {
    const response = await api.get(`${USER_API}/all`);
    return response.data;
};

// Update user
export const updateUser = async (id, userData) => {
    const response = await api.put(
        `${USER_API}/update/${id}`, userData);
    return response.data;
};

// Toggle user status
export const toggleUserStatus = async (id) => {
    const response = await api.put(
        `${USER_API}/toggle-status/${id}`, {});
    return response.data;
};

// Delete user
export const deleteUser = async (id) => {
    const response = await api.delete(
        `${USER_API}/delete/${id}`);
    return response.data;
};